import type React from 'react';
import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import AddIcon from 'assets/icons/icn _ 24px _ add.svg?react';
import EmailIcon from 'assets/icons/icn _ 24px _ email.svg?react';
import GroupAdd from 'assets/icons/icn _ 24px _ group-add.svg?react';
import PenaltyIcon from 'assets/icons/icn _ 24px _ Penalty.svg?react';
import PlayerProfileIcon from 'assets/icons/icn _ 24px _ User-circled.svg?react';
import { ActionsMenu, ActionsMenuItem } from 'components/popovers/actions/ActionsMenu';
import { useLevelConfig } from 'hooks/useLevelConfiguration';

export interface PlayerAvailableActions {
  PROFILE?: boolean;
  PENALTY?: boolean;
  EVENT?: boolean;
  TEAM?: boolean;
  EMAIL?: boolean;
}

interface PlayerActionsProps {
  actions: PlayerAvailableActions;
  open: boolean;
  anchorEl: () => HTMLElement | null;
  onOpenPlayersProfile: () => void;
  onSuspensionPointAction: () => void;
  onEventAction: () => void;
  onTeamAction: () => void;
  onEmailAction: () => void;
  onClose: () => void;
}

const PlayerActions: React.FC<React.PropsWithChildren<PlayerActionsProps>> = ({
  actions,
  open,
  anchorEl,
  onOpenPlayersProfile,
  onSuspensionPointAction,
  onEventAction,
  onTeamAction,
  onEmailAction,
  onClose,
}) => {
  const { t } = useTranslation();
  const { hideScorecardPlayerActions } = useLevelConfig();

  return useMemo(
    () => (
      <ActionsMenu anchorEl={anchorEl} id="player-actions-popover" open={open} onClose={onClose}>
        {actions.PROFILE && !hideScorecardPlayerActions && (
          <ActionsMenuItem icon={<PlayerProfileIcon />} text={t('viewProfile')} onClick={onOpenPlayersProfile} />
        )}
        {actions.PENALTY && !hideScorecardPlayerActions && (
          <ActionsMenuItem icon={<PenaltyIcon />} text={t('suspensionPoints')} onClick={onSuspensionPointAction} />
        )}
        {actions.EVENT && <ActionsMenuItem icon={<AddIcon />} text={t('addToEvent')} onClick={onEventAction} />}
        {actions.TEAM && <ActionsMenuItem icon={<GroupAdd />} text={t('addToTeam')} onClick={onTeamAction} />}
        {actions.EMAIL && <ActionsMenuItem icon={<EmailIcon />} text={'Send email'} onClick={onEmailAction} />}
      </ActionsMenu>
    ),
    [
      open,
      anchorEl,
      onClose,
      actions.PROFILE,
      actions.PENALTY,
      actions.EVENT,
      actions.TEAM,
      actions.EMAIL,
      hideScorecardPlayerActions,
      t,
      onOpenPlayersProfile,
      onSuspensionPointAction,
      onEventAction,
      onTeamAction,
      onEmailAction,
    ],
  );
};

export default PlayerActions;
